import { useState, FormEvent } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const ContactPage = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const textarea = form.querySelector("textarea");
    if (textarea && textarea.value.length > 500) {
      alert("메시지는 500자 이내로 입력해주세요.");
      return;
    }
    setLoading(true);
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    await fetch("https://readdy.ai/api/form/d7dmg9hnoju8nk5a1ch0", { method: "POST", body: data });
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="mb-12">
            <p className="text-xs font-bold tracking-widest uppercase text-stone-400 mb-2">Get in Touch</p>
            <h1 className="text-3xl md:text-4xl font-black text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>문의하기</h1>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Form */}
            <div>
              {submitted ? (
                <div className="flex flex-col items-center justify-center py-16 bg-stone-50 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-full mb-4">
                    <i className="ri-check-line text-2xl text-emerald-600" />
                  </div>
                  <h3 className="text-lg font-bold text-stone-900 mb-2">문의가 접수되었습니다!</h3>
                  <p className="text-sm text-stone-500 text-center">빠른 시일 내에 답변 드리겠습니다.</p>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-semibold text-stone-700 mb-1.5">이름 *</label>
                      <input name="name" required className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 outline-none focus:border-stone-400 transition-colors" placeholder="홍길동" />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-stone-700 mb-1.5">이메일 *</label>
                      <input name="email" type="email" required className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 outline-none focus:border-stone-400 transition-colors" placeholder="hello@example.com" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-stone-700 mb-1.5">문의 유형</label>
                    <select name="type" className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 outline-none focus:border-stone-400 bg-white cursor-pointer">
                      <option value="상품 문의">상품 문의</option>
                      <option value="배송 문의">배송 문의</option>
                      <option value="교환/반품">교환/반품</option>
                      <option value="기타">기타</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-stone-700 mb-1.5">제목 *</label>
                    <input name="subject" required className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 outline-none focus:border-stone-400 transition-colors" placeholder="문의 제목을 입력해주세요" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-stone-700 mb-1.5">메시지 * <span className="text-stone-400 font-normal">(최대 500자)</span></label>
                    <textarea name="message" required maxLength={500} rows={5} className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 outline-none focus:border-stone-400 transition-colors resize-none" placeholder="문의 내용을 입력해주세요" />
                  </div>
                  <button type="submit" disabled={loading} className="w-full bg-stone-900 text-white text-sm font-bold py-3.5 rounded-xl hover:bg-stone-700 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60">
                    {loading ? "전송 중..." : "문의 보내기"}
                  </button>
                </form>
              )}
            </div>

            {/* Info */}
            <div className="space-y-8">
              <div className="rounded-2xl overflow-hidden" style={{ height: "240px" }}>
                <iframe
                  title="도어준 위치"
                  src="https://maps.google.com/maps?q=%EA%B2%BD%EA%B8%B0%EB%8F%84+%EC%9D%98%EC%A0%95%EB%B6%80%EC%8B%9C+%EC%9A%A9%ED%98%84%EB%A1%9C+118&t=m&z=15&output=embed&iwloc=near"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="space-y-5">
                {[
                  { icon: "ri-map-pin-line", title: "주소", desc: "경기도 의정부시 용현로 118" },
                  { icon: "ri-time-line", title: "운영 시간", desc: "연중무휴 10:00 - 18:00" },
                  { icon: "ri-mail-line", title: "이메일", desc: "bnk2904@naver.com" },
                  { icon: "ri-phone-line", title: "전화", desc: "010-9793-9490" },
                ].map((info) => (
                  <div key={info.title} className="flex gap-4">
                    <div className="w-9 h-9 flex items-center justify-center bg-stone-100 rounded-lg flex-shrink-0">
                      <i className={`${info.icon} text-stone-600`} />
                    </div>
                    <div>
                      <p className="text-xs font-bold text-stone-700 mb-0.5">{info.title}</p>
                      <p className="text-sm text-stone-500 whitespace-pre-line">{info.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
